export default __webpack_public_path__ + "src/images/key.svg";